var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#104145"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5502 29.7502C24.6045 29.7502 29.5583 22.2469 29.5583 15.7421C29.5583 15.5312 29.5536 15.3155 29.5442 15.1046C30.5079 14.4077 31.3395 13.5445 32 12.5555C31.1025 12.9548 30.1496 13.2156 29.1739 13.329C30.2013 12.7132 30.9705 11.7457 31.3391 10.606C30.3726 11.1788 29.3156 11.5829 28.2134 11.8009C27.4708 11.0118 26.489 10.4894 25.4197 10.3143C24.3504 10.1392 23.2532 10.3213 22.2977 10.8323C21.3423 11.3434 20.5818 12.1549 20.1338 13.1416C19.6859 14.1282 19.5754 15.2349 19.8195 16.2905C17.8625 16.1923 15.9479 15.6839 14.2 14.7983C12.452 13.9127 10.9097 12.6697 9.67297 11.1498C9.0444 12.2335 8.85206 13.5159 9.13503 14.7363C9.418 15.9568 10.1551 17.0237 11.1964 17.7202C10.4146 17.6954 9.64998 17.4849 8.96563 17.1062V17.1671C8.96492 18.3044 9.3581 19.4068 10.0783 20.287C10.7985 21.1672 11.8013 21.7708 12.9162 21.9952C12.1921 22.1934 11.432 22.2222 10.6948 22.0796C11.0095 23.0577 11.6216 23.9131 12.4458 24.5266C13.27 25.14 14.2651 25.4808 15.2923 25.5015C13.5484 26.8714 11.3942 27.6144 9.17656 27.6109C8.78329 27.6103 8.3904 27.5861 8 27.5387C10.2529 28.984 12.8735 29.7516 15.5502 29.7502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.aaa61193889eac7029b1aa1ae4827efb.svg";
export { ForwardRef as ReactComponent };